import z from 'zod';

import { IdSchema } from '../../base';
import {
  PronunciationDescriptionSchema,
  PronunciationEntitySchema,
  PronunciationLanguageCodeSchema,
  PronunciationNameSchema,
  PronunciationPositionSchema,
} from './pronunciations.schema';

export const CreatePronunciationSchema = PronunciationEntitySchema.extend({
  languageCode: PronunciationLanguageCodeSchema.default(''),
  description: PronunciationDescriptionSchema.default(''),
  position: PronunciationPositionSchema.default(0),
  name: PronunciationNameSchema.default(''),
}).describe(
  'Create a TTS pronunciation rule that replaces text matching a regex before it is spoken',
);

export type CreatePronunciationPayload = z.infer<
  typeof CreatePronunciationSchema
>;

export const DeletePronunciationSchema = z
  .object({
    id: IdSchema,
  })
  .describe('Delete a TTS pronunciation rule by its ID');

export type DeletePronunciationPayload = z.infer<
  typeof DeletePronunciationSchema
>;

export const UpdatePronunciationSchema = PronunciationEntitySchema.partial()
  .required({ id: true })
  .describe("Update a TTS pronunciation rule's properties");

export type UpdatePronunciationPayload = z.infer<
  typeof UpdatePronunciationSchema
>;

const PronunciationPositionUpdateSchema = z.object({
  id: IdSchema,
  position: PronunciationPositionSchema,
});

export const ReorderPronunciationsSchema = z
  .object({
    newPositions: z.array(PronunciationPositionUpdateSchema).min(1),
  })
  .describe('Reorder pronunciation rules by updating their positions');

export type ReorderPronunciationsPayload = z.infer<
  typeof ReorderPronunciationsSchema
>;
